import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {EquipmentEnums} from '@namespaces/equipment.namespace';
import {CalibrationLabelPipe} from '@pipes/calibration-label/calibration-label.pipe';

@Component({
    selector: 'app-calibration-info',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: '{{message}}',
    styles: [`
        :host {
            display: block;
        }
    `]
})

export class CalibrationInfoComponent implements OnInit {
    @Input() verificationStatus: EquipmentEnums.VerificationStatus;
    public message: string;

    constructor(
        private calibrationLabelPipe: CalibrationLabelPipe
    ) {}

    ngOnInit() {
        // Если поверяется, то один текст, иначе другой
        if (this.verificationStatus === EquipmentEnums.VerificationStatus.inapplicable) {
            this.message = `Это оборудование не является средством измерения и не требует метрологической аттестации.
            Однако, при необходимости, вы можете прикрепить данные о техническом освидетельствовании или любые другие документы
            (акты, свидетельства), подтверждающие исправность оборудования.`;
        } else {
            this.message = `Данное оборудование
            ${this.calibrationLabelPipe.transform(this.verificationStatus, 'должно быть поверено', 'подлежит калибровке')},
            так как является средством измерения. Укажите данные актуального Свидетельства о
            ${this.calibrationLabelPipe.transform(this.verificationStatus, 'поверке', 'калибровке')}.
            Мы рекомендуем также прикрепить его скан-копию, чтобы она всегда была у вас «под рукой».`;
        }
    }
}
